;(function ( $ ) {

    /**
     *  productChooser
     *  calculate totals for tickets
     **/

    'use strict';

    // Create the defaults once
    var pluginName = 'productChooser';
    var defaults = {};

    // The actual plugin constructor
    function Plugin ( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        init: function () {
            this.currency = $(this.element).find('.ticket-totals .price').data('currency');
            this.ticketList = $(this.element).find('.ticket-totals .tickets');
            this.ticketPrices = $(this.element).find('.ticket-totals .price');
            this.calculateTotals();
            this.registerEvents();
        },

        registerEvents: function() {
            var _this = this;
            var totalBoxPos = $('.ticket-totals').offset().top - $('.ticket-totals').height();
            $(window).on('number.change', function(e) {
                _this.calculateTotals();
            });
            $(window).on('scroll', function (e){
                _this.checkFloatingTotalBox('.ticket-totals',totalBoxPos);
            });
            $(this.element).find('.show-voucher-form').on('click', function(e) {
                e.preventDefault();
                $('#voucher-form').removeClass('is-hidden').addClass('animated fadeIn');
                $(this).addClass('animated fadeOut');
                $(this).one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
                    $(this).remove();
                });
            });
            $(this.element).find('#show-products').on('click', function(e) {
                e.preventDefault();
                $(this).addClass('animated fadeOut');
                $(this).one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
                    $(this).remove();
                });
                $('#products').removeClass('is-hidden').addClass('animated fadeIn');
            });
            $(this.element).find('.ticket-card--single').on('click', function (){
                $(this).toggleClass('selected');
                if(! $(this).hasClass('selected')){
                    $(this).addClass('bg-color-event-fg');
                    $(this).addClass('border-color-event');
                    $(this).removeClass('bg-color-event');
                    $(this).find('sup a').addClass('bg-color-event-fg');
                    $(this).find('sup a').removeClass('color-event-fg');
                }else{
                    $(this).removeClass('bg-color-event-fg');
                    $(this).removeClass('border-color-event');
                    $(this).addClass('bg-color-event');
                    $(this).find('sup a').removeClass('bg-color-event-fg');
                    $(this).find('sup a').addClass('color-event-fg');
                }
                _this.calculateTotals();
            });
            $(this.element).find('.ticket-card--single').on('mouseenter', function (){
                if(!$(this).hasClass('selected')){
                    $(this).removeClass('bg-color-event-fg');
                    $(this).removeClass('border-color-event');
                    $(this).addClass('bg-color-event');
                    $(this).find('sup a').removeClass('bg-color-event-fg');
                    $(this).find('sup a').addClass('color-event-fg');
                }
            });
            $(this.element).find('.ticket-card--single').on('mouseleave', function (){
                if(!$(this).hasClass('selected')){
                    $(this).addClass('bg-color-event-fg');
                    $(this).addClass('border-color-event');
                    $(this).removeClass('bg-color-event');
                    $(this).find('sup a').addClass('bg-color-event-fg');
                    $(this).find('sup a').removeClass('color-event-fg');
                }
            });
            // $(this.element).find('.text-submit input').on('keydown', function(e) {
            //     if (e.keyCode == 13) {
            //         e.preventDefault();
            //         _this.checkVoucherCode($(this).val());
            //     }
            // });
            // $(this.element).find('.text-submit button').on('click', function(e) {
            //     e.preventDefault();
            //     _this.checkVoucherCode($(_this.element).find('.text-submit input').val());
            // });
        },
        checkFloatingTotalBox: function (element,totalBoxPos) {
            // if($(window).scrollTop() + $(window).height() < totalBoxPos){
            //     $(element).addClass('ticket-totals--floating');
            // }else{
            //     $(element).removeClass('ticket-totals--floating');
            // }
            
        },
        calculateTotals: function() {
            /* TODO refactor for better performance */
            var _this = this;
            var totalTickets = 0;
            var totalPrice = 0;
            var tickets;
            var pricetext;
            var price;
            var cleanprice;

            _this.ticketList.empty();

            $(this.element).find('.ticket-card, .voucher-card').each(function() {
                if($(this).find('.quantity').length > 0){
                    //Case with tickets having a quantity selector
                    tickets = parseInt($(this).find('.quantity').val());
                }else{
                    //Single tickets
                    tickets = $(this).hasClass('selected') ? 1 : 0;
                }
                pricetext = $(this).find('.price').text().replace(' ', '').replace('.', '').replace(',', '.');
                price = parseFloat(pricetext);
                if (!price) price = 0;

                //remove ,00 prices in ticket cards
                cleanprice = pricetext.replace('.00', ' ');
                if (pricetext !== cleanprice) $(this).find('.price').text(cleanprice);

                totalTickets += tickets;
                price *= tickets;
                totalPrice += price;

                if (tickets && $(this).find('.quantity').length > 0) {
                    //total price in card
                    price = price.toFixed(2).toString().replace('.', ',');
                    $(this).find('.total-price').text(price.replace(',00', '') + ' ' + _this.currency);

                    //price and amount in totals on bottom
                    price = (price == "0,00") ? ('') : (price + ' ' + _this.currency);
                    tickets = (tickets >> 1) ? (tickets + ' ' +  $(this).data('plural')) : (tickets + ' ' +  $(this).data('singular'));
                    _this.ticketList.append('<tr><td>' + tickets  + '</td><td>' + price + '</td></tr>');



                } else {
                    //clear total price in card
                    $(this).find('.total-price').empty();
                }
            });

            if (totalPrice > 0) {
                $(this.element).find('.ticket-totals .vat-disclaimer').show();
            } else {
                $(this.element).find('.ticket-totals .vat-disclaimer').hide();
            }
            if (totalTickets > 0) {
                $(this.element).find('.form-actions button').removeAttr('disabled');
            } else {
                $(this.element).find('.form-actions button').attr('disabled', 'disabled');
            }

            totalPrice = totalPrice.toFixed(2).toString().replace('.', ',');
            _this.ticketPrices.text(totalPrice + ' ' + _this.currency);

        }
    });

    $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
            if ( !$.data( this, 'plugin_' + pluginName ) ) {
                $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
            }
        });
    };
})( jQuery );
